import Vue from 'vue';

import { E入力分類, Eフェーズ種別 } from '@/openapi/enum';
import { Cデータ償却, YearValue, データRequest } from '@/openapi/user';

import { 計算減価償却 } from '@/classes/service/分析計画/償却Type';

export default Vue.extend({
  name: 'M償却保存Mixin',

  methods: {
    create減価償却s(
      年次計算減価償却Map: Map<number, 計算減価償却>,
      input減価償却s: (YearValue | null)[] = []
    ): YearValue[] {
      return [...年次計算減価償却Map.keys()].map((year) => {
        const 計算減価償却 = 年次計算減価償却Map.get(year);
        const input減価償却 = input減価償却s.find((input) => input !== null && input.year === year);
        return {
          year,
          value: input減価償却 !== null && input減価償却 !== undefined ? input減価償却.value : 計算減価償却!.減価償却費,
        };
      });
    },

    create償却データRequest(番号: number, eフェーズ種別: Eフェーズ種別, cデータ償却: Cデータ償却): データRequest {
      return {
        c入力分類: E入力分類.償却,
        c番号: 番号,
        cフェーズ種別: eフェーズ種別,
        c取り込みキー: cデータ償却.資産コード === '' ? undefined : cデータ償却.資産コード,
        cデータ: JSON.stringify(cデータ償却),
      };
    },
  },
});
